module.exports = __webpack_public_path__ + "static/media/earlybirds.0fe214e3.svg";